<script>
    import { createEventDispatcher } from 'svelte';
    import { generateID } from '../utils/Data.svelte';
    export let modal;
    
	  const dispatch = createEventDispatcher();

    async function responseHandler(response) {
        modal.handler(modal.data, response);
    }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <div>{modal.message}</div>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error"></div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-primary" on:click|stopPropagation={(e) => {
                        e.currentTarget.blur();
                        responseHandler(true);
                      }}>Yes</button>
                    <button class="btn btn-primary" on:click|stopPropagation={(e) => {
                        e.currentTarget.blur();
                        responseHandler(false);
                      }}>No</button>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
  .btn {
    width: 75px;
  }
</style>